export const specialConsultationDTOFields = {
    id: 'id',
    journalId: 'journalId',
    subject: 'subject',
    date: 'date',
    description: 'description',
    contactWith: 'contactWith',
    childrenArray: 'childrenArray',
} as const;
